import React from 'react';
import { motion } from 'framer-motion';
export function Timeline() {
  return <section className="py-20 bg-white border-t border-slate-100" data-id="element-277">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-278">
        <div className="text-center mb-12" data-id="element-279">
          <h2 className="text-2xl font-serif font-bold text-slate-900" data-id="element-280">
            Rapid Turnaround
          </h2>
        </div>

        <div className="relative" data-id="element-281">
          {/* Horizontal Line */}
          <div className="absolute top-1/2 left-0 w-full h-0.5 bg-slate-200 -translate-y-1/2 hidden md:block" data-id="element-282" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-283">
            {[{
            time: 'Day 0',
            title: 'Send Export',
            desc: 'Upload load file + natives'
          }, {
            time: '24 Hours',
            title: 'Initial Assessment',
            desc: 'Count & time estimate confirmed'
          }, {
            time: '48-72 Hours',
            title: 'Delivery',
            desc: 'Final analysis delivered'
          }].map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} className="relative flex flex-col items-center text-center bg-white p-4 z-10" data-id="element-284">
                <div className="w-4 h-4 rounded-full bg-amber-500 border-4 border-white shadow-sm mb-4 md:mb-6" data-id="element-285" />
                <span className="text-xs font-bold text-amber-600 uppercase tracking-wider mb-1" data-id="element-286">
                  {item.time}
                </span>
                <h3 className="text-lg font-bold text-slate-900 mb-1" data-id="element-287">
                  {item.title}
                </h3>
                <p className="text-sm text-slate-500" data-id="element-288">{item.desc}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}